import gql from "graphql-tag";

export const GET_EVENT_LAST_TRANS = gql`
  query event_last_transactions($event_id: uuid!, $limit: Int) {
    event_attendees(
      where: { event_id: { _eq: $event_id }, is_going: { _eq: true } }
    ) {
      created_at
      quantity
      purchased_price
      users_view {
        full_name
        name
        lastname
      }
      event_paid_ticket_detail {
        option_name
      }
    }
  }
`;
